import { Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import BotonCheck from "../../../components/Boton/BotonCheck";
import { SinGuardar } from "../../../components/Boton/SinGuardar";
import { startPostFase } from "../../../context/actions/cotizacionesActions";

////
export default function ButtonContinuar() {
  const {
    cotizacion: { step },
    seccionModificada: { articulos },
  } = useSelector((state) => state.cotizacionesReducer);

  const dispatch = useDispatch();
  const accionBoton = () => {
    dispatch(startPostFase("fase2"));
  };

  return (
    <Row justify="end" style={{ marginTop: 15 }}>
      <Col>
        <SinGuardar show={articulos} />
      </Col>
      <Col>
        <BotonCheck
          tooltip="Continuar"
          onClick={accionBoton}
          style={step > 2 ? { color: "green" } : { color: "#ad7100" }}
        />
      </Col>
    </Row>
  );
}
